import { render, staticRenderFns } from "./ListROReversalRequest.vue?vue&type=template&id=03d5af37&scoped=true"
import script from "./ListROReversalRequest.vue?vue&type=script&lang=js"
export * from "./ListROReversalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5af37",
  null
  
)

export default component.exports